/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
          //if($(".text__box").height() > 95) {$(".text__box").css("overflow-y", "scroll");}

        // JavaScript to be fired on all pages
          $('.owl-carousel').owlCarousel({
              loop:true,
              margin:10,
              nav:true,
              autoplay:true,
              autoplayTimeout:9000,
              animateIn: 'fadeInLeft',
              smartSpeed:800,
              responsive:{
                  0:{
                      items:1,
                      margin:0
                  },
                  880:{
                      items:2
                  },
                  992:{
                      items:1
                  }
              }
          });
          if (window.matchMedia("(max-width: 1000px)").matches) {
              $(".team").addClass("owl-carousel");
              $('.team.owl-carousel').owlCarousel({
                  stagePadding: 50,
                  loop:true,
                  margin:10,
                  nav:true,
                  responsive:{
                      0:{
                          stagePadding: 30,
                          items:1
                      },
                      375:{
                          items:1
                      },
                      1000:{
                          items:1
                      }
                  }
              });

          }
          if (window.matchMedia("(max-width: 1200px)").matches) {
                $(".slide__spec").addClass("centred");
          }
          /*carousel videos*/
          var s = new Swiper('.videos .swiper-container', {
              loop: true,
              spaceBetween: 0,
              slidesPerView: 1,
              centeredSlides: true,
              navigation: {
                  prevEl: '.videos .swiper-button-prev',
                  nextEl: '.videos .swiper-button-next'
              },
              pagination: {
                  el: '.videos .swiper-pagination',
                  clickable: true,
              }

          });
          var st = new Swiper('.rs__section .swiper-container', {
              loop: true,
              spaceBetween: 80,
              slidesPerView: 1.5,
              centeredSlides: true,
              navigation: {
                  prevEl: '.rs__section .swiper-button-prev',
                  nextEl: '.rs__section .swiper-button-next'
              },
              pagination: {
                  el: '.rs__section .swiper-pagination',
                  clickable: true,
              },
              breakpoints: {
                  1900: {
                      slidesPerView: 1.5,
                      spaceBetween: 50,
                  },
                  1600: {
                      slidesPerView: 1.5,
                      spaceBetween: 30,
                  },
                  1440: {
                      slidesPerView: 1.5,
                      spaceBetween: 20,
                  },
                  1200: {
                      slidesPerView: 1,
                      spaceBetween: 0,
                  }
              }
          });






          /*carousel print*/
          var print = new Swiper('.prints .swiper-container', {
              loop: true,
              spaceBetween: 0,
              slidesPerView: 1,
              centeredSlides: true,
              navigation: {
                  prevEl: '.prints .swiper-button-prev',
                  nextEl: '.prints .swiper-button-next'
              },
              pagination: {
                  el: '.prints .swiper-pagination',
                  clickable: true,
              }

          });

/* scroll*/
          (function ($) {
              $(window).on("load", function () {
                  /* Page Scroll to id fn call */
                  $("a").mPageScroll2id({
                      offset: 100
                  });

              });
          })(jQuery);

          //console.log(get__height);

          if (window.matchMedia("(min-width: 1024px)").matches) {
              setTimeout(function () {
                  $('.video .section__content a').fadeOut('slow');

              }, 2000);
          }

              setTimeout(function () {
                  //$('.video .section__content a').fadeOut('slow');
                  $('.video .section__content .bg__video').fadeOut('slow');

              }, 2000);

          $(window).on("scroll", function () {
              if ($(this).scrollTop() > 500) {
                  $('.nav').fadeIn('slow');
              } else {
                  $('.nav').fadeOut('slow');
              }
          });

        var $window = $(window);
          var nav = $('.nav');

          $window.on('scroll', function(){
              var scrollTop = $window.scrollTop();
              if(scrollTop){
                  nav.removeClass('hidden');
              }
          });
          // Setup isScrolling variable
         // var isScrolling;

// Listen for scroll events
         /* window.addEventListener('scroll', function ( event ) {

              // Clear our timeout throughout the scroll
              window.clearTimeout( isScrolling );

              // Set a timeout to run after scrolling ends
              isScrolling = setTimeout(function() {

                  nav.addClass('hidden');
                  console.log( 'Scrolling has stopped.' );

              }, 66);

          }, false);*/

          $( ".form__footer .btn__send" ).on( "click", function() {
              $( ".wpcf7-form" ).submit();
          });

          $("video").prop('muted', true);


          $("#mute-video").click( function (){
              if( $("video").prop('muted') ) {
                  $("video").prop('muted', false);
                  $("#mute-video").addClass('up');
              } else {
                  $("video").prop('muted', true);
                  console.log('true');
                  $("#mute-video").removeClass('up');
              }
          });
          /*if (window.matchMedia("(max-width: 767px)").matches) {
              $("video").prop('muted', true);
          }
*/

          /*************************************************************/

          $(window).on('beforeunload', function(){
              $(window).scrollTop(0);
          });

          var UIScrollWatcher = (function () {
              function viewportScrollY () {
                  return window.scrollY || window.pageYoffset || document.documentElement.scrollTop || document.body.scrollTop;
              }

              function viewportHeight () {
                  return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
              }

              function elementBounds (el) {
                  var r = el.getBoundingClientRect(),
                      s = viewportScrollY();

                  return {
                      top: r.top + s,
                      bottom: r.bottom + s,
                      height: r.height
                  };
              }



              var set, metrics, onTriggerOn, onTriggerOff, onScrollDirectionChange;

              var previousScroll = 0;

              var scrollDirection = 1;



              function init (options) {
                  set = Array.prototype.slice.call(document.querySelectorAll(options.target));
                  metrics = [];

                  onTriggerOn = options.onTriggerOn || null;
                  onTriggerOff = options.onTriggerOff || null;
                  onScrollDirectionChange = options.onScrollDirectionChange || null;

                  update();
                  doYourThing();

                  window.addEventListener('scroll', onScroll);
                  window.addEventListener('resize', onResize);
              }

              function update () {
                  var vh = viewportHeight();
                  var b;

                  for(var i = 0 ; i < set.length ; i++) {
                      b = elementBounds(set[i]);
                      metrics[i] = {
                          el: set[i],
                          triggerOn: b.top - vh / 2,
                          triggerOff: b.bottom - vh / 2,
                          isOn: false
                      }
                  }

                  metrics.length = i;
              }

              function onScroll (ev) {
                  doYourThing();
              }

              function onResize (ev) {
                  update();
                  doYourThing();
              }

              function doYourThing () {
                  var s = viewportScrollY();
                  var m;
                  var unchanged = true;

                  for(var i = 0 ; i < metrics.length ; i++) {
                      m = metrics[i];

                      if(s < m.triggerOn && previousScroll > m.triggerOff) {
                          doOn(m, s - previousScroll);
                          doOff(m, s - previousScroll);
                          unchanged = false;
                      }
                      else if(s > m.triggerOff && previousScroll < m.triggerOn) {
                          doOn(m, s - previousScroll);
                          doOff(m, s - previousScroll);
                          unchanged = false;
                      }
                      else if(s > m.triggerOn && s < m.triggerOff && !m.isOn) {
                          doOn(m, s - previousScroll);
                          unchanged = false;
                      }
                      else if((s < m.triggerOn && m.isOn) || (s > m.triggerOff && m.isOn)) {
                          doOff(m, s - previousScroll);
                          unchanged = false;
                      }
                  }

                  if(unchanged) {
                    if(scrollDirection > 0 && s - previousScroll < 0) {
                      scrollDirection = -1;
                      onScrollDirectionChange && onScrollDirectionChange.call(this, scrollDirection);
                    }
                    else if(scrollDirection < 0 && s - previousScroll > 0) {
                      scrollDirection = 1;
                      onScrollDirectionChange && onScrollDirectionChange.call(this, scrollDirection);
                    }
                  }

                  previousScroll = s;
              }

              function doOn (metricsObject, scrollDelta) {
                  metricsObject.isOn = true;
                  onTriggerOn && onTriggerOn.call(metricsObject.el, metricsObject.el, scrollDelta);
              }

              function doOff (metricsObject, scrollDelta) {
                  metricsObject.isOn = false;
                  onTriggerOff && onTriggerOff.call(metricsObject.el, metricsObject.el, scrollDelta);
              }



              return {
                  init: init,
                  doYourThing: doYourThing,
                  update: update
              };
          })();





          var UIStory = (function () {
              var el, playhead, lines, metrics, previous, current, next;

              var index = 0,
                  position = 0,
                  nudge = 48;



              function init (options) {
                  el = options.target;
                  playhead = el.querySelector('.story__playhead');
                  lines = Array.prototype.slice.call(playhead.querySelectorAll('.story__line'));
                  // previous = el.querySelector('.story__line--previous');
                  // current = el.querySelector('.story__line--current');
                  // next = el.querySelector('.story__line--next');

                  index = Math.min(options.index || 1, 1);

                  update();

                  for(var i = 0 ; i < lines.length ; i++) {
                    if(i == index - 1) { previous = lines[i]; }
                    else if(i == index) { current = lines[i]; }
                    else if(i == index + 1) { next = lines[i]; }
                  }

                  previous.classList.add('story__line--previous');
                  current.classList.add('story__line--current');
                  next && next.classList.add('story__line--next');

                  position = metrics[index - 1].localY * -1;

                  playhead.style.transform = 'translateY(' + position + 'px)';
              }

              function update () {
                  metrics = [];
                  for(var i = 0 ; i < lines.length ; i++) {
                    metrics[i] = {
                      el: lines[i],
                      localY: lines[i].offsetTop,
                      containerHeight: lines[i].offsetHeight + (i > 0 ? lines[i - 1].offsetHeight : 0) + (i < lines.length - 1 ? lines[i + 1].offsetHeight : 0)
                    };
                  }
              }

              function goTo (i) {
                  if(!el || i == index) return;

                  index = Math.min(lines.length - 1, Math.max(i, 1));
                  position = metrics[index - 1].localY * -1;

                  var toBeCurrent = lines[index],
                      toBePrevious = lines[index - 1],
                      toBeNext = lines[index + 1] ? lines[index + 1] : null;

                  el.style.height = metrics[index].containerHeight + 'px';
                  playhead.style.transform = 'translateY(' + position + 'px)';

                  current.classList.remove('story__line--current');
                  previous.classList.remove('story__line--previous');
                  next && next.classList.remove('story__line--next');

                  toBeCurrent.classList.add('story__line--current');
                  toBePrevious.classList.add('story__line--previous');
                  toBeNext && toBeNext.classList.add('story__line--next');

                  current = toBeCurrent;
                  previous = toBePrevious;
                  next = toBeNext;
              }

              function previous () {
                  if(!el || index <= 1) return;
                  goTo(index - 1);
              }

              function next () {
                  if(!el || index >= lines.length - 1) return;
                  goTo(index + 1);
              }



              return {
                  init: init,
                  update: update,
                  goTo: goTo,
                  previous: previous,
                  next: next
              };
          })();





           function navItemForSection (section) {
              return section.id ? document.querySelector('.nav__item[href="#' + section.id + '"]') : null;
          }



          var currentSection;

          function parseStoryProceedString (str) {
              var str = str.split(';').map(function (item) { return item.split(':') });
              var obj = {};
              for(var i = 0 ; i < str.length ; i++) {
                obj[str[i][0]] = {
                    action: str[i][1] ? str[i][1] : 'proceed',
                    index: str[i][2] ? parseInt(str[i][2]) : undefined
                };
              }
              return obj;
          }

          function storyProceedAccordingToSection (section, scrollDirection) {
              var storyProceed = section.hasAttribute('data-story-proceed');

              if(storyProceed) {
                  storyProceed = parseStoryProceedString(section.getAttribute('data-story-proceed') || 'both:proceed');

                  if(scrollDirection > 0) {
                      if('down' in storyProceed) {
                          UIStory[storyProceed.down.action == 'proceed' ? 'next' : storyProceed.down.action](storyProceed.down.index);
                      }
                      else if('both' in storyProceed) {
                          UIStory[storyProceed.both.action == 'proceed' ? 'next' : storyProceed.both.action](storyProceed.both.index);
                      }
                  }
                  else if(scrollDirection < 0) {
                      if('up' in storyProceed) {
                          UIStory[storyProceed.up.action == 'proceed' ? 'previous' : storyProceed.up.action](storyProceed.up.index);
                      }
                      else if('both' in storyProceed) {
                          UIStory[storyProceed.both.action == 'proceed' ? 'previous' : storyProceed.both.action](storyProceed.both.index);
                      }
                  }
              }
          }

          UIScrollWatcher.init({
              target: '.scroll-watcher-target',
              onTriggerOn: function (el, scrollDelta) {
                  var navItemIn = navItemForSection(el);

                  if(currentSection) {
                      var navItemOut = document.querySelector('.nav__item--current');

                      currentSection.classList.remove('section--current');

                      if(navItemIn && navItemOut) {
                          navItemOut.classList.remove('nav__item--current');
                      }
                  }

                  currentSection = el;
                  currentSection.classList.add('section--current');

                  if(navItemIn) {
                      navItemIn.classList.add('nav__item--current');
                  }

                  storyProceedAccordingToSection(currentSection, scrollDelta);
              },
              onScrollDirectionChange: function (direction) {
                storyProceedAccordingToSection(currentSection, direction);
              }
          });



          UIStory.init({
              target: document.querySelector('.story')
          });



          window.addEventListener('resize', function () {
              UIScrollWatcher.update();
              UIStory.update();
              UIScrollWatcher.doYourThing();
          });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
